import React from 'react'
import Button from '@mui/material/Button'
import { useTranslate, TextInput } from 'react-admin'
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import SaveIcon from '@mui/icons-material/Save'
import HTMLInput from 'src/components/uiElements/fields/HTMLInput'

export const EmailModalSetting = ({ open, index, handleClose }) => {
  const translate = useTranslate()
  console.log("EmailModalSetting hola");
  return (
    <Dialog open={open} onClose={handleClose} maxWidth='md' fullWidth={true}>
      <DialogTitle>{translate('ra.field.setting_email')}</DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>
          <EditInputsWrap label={translate('ra.field.status')}>
            <TextInput source={`setting_email.${index}.status`} label={false} fullWidth />
          </EditInputsWrap>

          {/* <EditInputsWrap label={translate('ra.field.logo')} xs={12} md={4}>
            <ImageInput source={`setting_email.${index}.header_logo`} label={''}>
              <ImageField source='src' title='title' />
            </ImageInput>
          </EditInputsWrap> */}

          <Grid item xs={12}>
            <HTMLInput
              label={translate('ra.field.header')}
              labelId='header'
              source={`setting_email.${index}.header`}
            />
          </Grid>

          <EditInputsWrap label={translate('ra.field.subject')} xs={12} md={12}>
            <TextInput source={`setting_email.${index}.subject`} label={false} fullWidth multiline />
          </EditInputsWrap>

          <Grid item xs={12}>
            <HTMLInput
              label={translate('ra.field.greeting')}
              labelId='greeting'
              source={`setting_email.${index}.greeting`}
            />
          </Grid>

          {/* <EditInputsWrap label={translate('ra.field.logo')} xs={12} md={4}>
            <ImageInput source={`setting_email.${index}.content_logo`} label={''}>
              <ImageField source='src' title='title' />
            </ImageInput>
          </EditInputsWrap> */}

          <Grid item xs={12}>
            <HTMLInput
              label={translate('ra.field.content')}
              labelId='content'
              source={`setting_email.${index}.content`}
            />
          </Grid>

          {/* <EditInputsWrap label={translate('ra.field.logo')} xs={12} md={4}>
            <ImageInput source={`setting_email.${index}.footer_logo`} label={''}>
              <ImageField source='src' title='title' />
            </ImageInput>
          </EditInputsWrap> */}

          <Grid item xs={12}>
            <HTMLInput
              label={translate('ra.field.footer')}
              labelId='footer'
              source={`setting_email.${index}.footer`}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions className='dialog-actions'>
        <Button startIcon={<SaveIcon />} variant='contained' onClick={() => handleClose()} type='sumbit'>
          {translate('ra.action.back')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
